<template>
  <div>
    <v-toolbar
      flat
      class="mt-4 px-0"
      color="transparent"
    >
      <h6 class="text-h6">
        ベースとなるテンプレートをお選びください
      </h6>
    </v-toolbar>

    <v-row class="px-0">
      <v-col
        v-for="m in models"
        :key="m.id"
        class="d-flex flex-column"
        cols="12"
        sm="4"
      >
        <v-card
          class="flex d-flex flex-column"
          link
          :to="{ name: 'Model', params: { id: m.id } }"
        >
          <v-img
            :cover="true"
            :src="m.image"
            height="200px"
          />
          <v-card-title class="pb-0 mb-1">
            {{ m.name }}
          </v-card-title>
          <v-card-text class="pt-0 mb-1">
            {{ m.description }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script type="ts">

import { API, Storage } from 'aws-amplify';
import * as mutations from '@/graphql/mutations';
import * as queries from '@/graphql/queries';
import { v4 as uuidv4 } from 'uuid';

import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ModelList',
  data: () => ({
    dialog: false,
    formValid: true,
    formRules: [v => !!v || v === 0 || '必須の項目です'],
    editedIndex: -1,
    editedItem: {
      name: "",
      description: "",
      boundaryJSON: null,
    },
    defaultItem: {
      name: "",
      description: "",
      boundaryJSON: null,
    },
    boundaryJSONFile: null,
    models: [
      {
        id: 's',
        name: 'S Model',
        image: require("@/assets/images/top/S_EX-A_0425_01.jpg"),
        description: '自然のなかで過ごす静謐なひとときが、あなたの心をととのえる。 この小さな拠点から、あなたの楽しみがはじまる。ひとりでも、みんなと一緒でも。大自然と向き合う最小限のキャビンです。'
      },
      {
        id: 'm',
        name: 'M Model',
        image: require("@/assets/images/top/M_EX-B_0425_01.jpg"),
        description: '友人と囲む食卓も、作業に没頭するアトリエも。 自然とつながるこの場所で、あなただけの創造的な暮らしがはじまる。暮らすと働くが一体になった、離れ付きの平屋です。'
      },
      {
        id: 'l',
        name: 'L Model',
        image: require("@/assets/images/top/L_EX-A_0425_01.jpg"),
        description: '大きな吹き抜けに、光が差し込む居心地の良いリビング。愛する人たちと共に過ごす時間が、あなたの人生をもっと豊かにする。みんなで集うことができる、開放感のある2階建て住宅です。',
      }
    ]
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? '新規' : '編集'
    },

    boundaryJSONFileLabel () {
      const { boundaryJSON } = this.editedItem;
      return boundaryJSON ? boundaryJSON.name : '土地境界線JSON';
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  created () {
  },

  methods: {

    addItem () {

      this.dialog = true;
      if (!this.formValid) {
        this.$refs.form.resetValidation();
      }

    },

    editItem (item) {

      this.editedIndex = this.lands.indexOf(item);

      Object.keys(this.editedItem).map(key => {
        this.editedItem[key] = item[key];
      });

      this.editedItem['id'] = item.id;
      this.dialog = true;

    },

    close () {

      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });

    },

    /**
     * 入力情報保存
     */
    async save () {

      if (this.formValid) {
        // JSONファイルアップロード
        if (this.boundaryJSONFile) {
          const boundaryJSONFile = this.boundaryJSONFile[0];
          const res = await this.uploadFile(boundaryJSONFile);
          this.editedItem.boundaryJSON = {
            name: boundaryJSONFile.name,
            key: res.key
          };
        }

        if (this.editedIndex > -1) {
          // 更新
          const item = await this.updateLand(this.editedItem);
          Object.assign(this.lands[this.editedIndex], item);
        } else {
          // 作成
          const item = await this.createLand(this.editedItem);
          this.lands.push(item);
        }

        this.close();
        this.boundaryJSONFile = null;
      }

    },

    /**
     * 土地作成
     */
    async createLand (input) {

      const res = await API.graphql({
        query: mutations.createLand,
        variables: { input }
      });

      return res.data.createLand;

    },

    /**
     * 土地更新
     */
    async updateLand (input) {

      const res = await API.graphql({
        query: mutations.updateLand,
        variables: { input }
      });

      return res.data.updateLand;

    },

    /**
    * 土地リスト
    */
    async listLands () {

      const res = await API.graphql({
        query: queries.listLands
      });

      this.lands = res.data.listLands.items;

    },

    /**
     * ファイルをS3にアップロードする
     */
    async uploadFile (file) {

      const name = file.name.replace('.json', '');
      const key = `boundary-json/${name}-${uuidv4()}.json`;

      const res = await Storage.put(key, file);
      return res;

    }
  },
})
</script>
